module.exports = __webpack_public_path__ + "img/register-2.73af9d42.svg";